// NATIVE 
import { useEffect, useState } from 'react';


// INSTALLED 
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Grid, TextField } from '@mui/material';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';


// CUSTOM 
import InputField from '../../formFields/InputField';
import CheckboxField from '../../formFields/checkBoxField';





/**
 * CreateCargo component is responsible for rendering a form to create a new cargo.
 * It utilizes various form fields and checkboxes to gather necessary information.
 * 
 * @param {any} props - The properties passed to the component.
 * @returns {JSX.Element} The rendered component.
 * 
 * @component
 * 
 * @example
 * // Example usage:
 * <CreateCargo formField={formField} />
 * 
 * @typedef {Object} FormField
 * @property {Object} name - The name field configuration.
 * @property {Object} description - The description field configuration.
 * @property {Object} area - The area field configuration.
 * @property {Object} visita_domiciliaria - The visita_domiciliaria checkbox configuration.
 * @property {Object} prueba_psicotecnica - The prueba_psicotecnica checkbox configuration.
 * @property {Object} examen_alimentos - The examen_alimentos checkbox configuration.
 * @property {Object} examen_alturas - The examen_alturas checkbox configuration.
 * @property {Object} certificado_laboral - The certificado_laboral checkbox configuration.
 * @property {Object} certificado_estudios - The certificado_estudios checkbox configuration.
 * @property {Object} adres - The adres checkbox configuration.
 * @property {Object} antecedentes_judicial - The antecedentes_judicial checkbox configuration.
 * @property {Object} entrevista - The entrevista checkbox configuration.
 * @property {Object} sociodemografica - The sociodemografica checkbox configuration.
 * @property {Object} dme - The dme checkbox configuration.
 * @property {Object} sst - The sst checkbox configuration.
 * 
 * @typedef {Object} Props
 * @property {FormField} formField - The form field configurations.
 * 
 * @param {Props} props - The properties passed to the component.
 */
export const CreateCargo = (props:any) => {


    // USE STATE 
    const [areas_select, setAreasSelect] = useState([]);


    // USE SELECTOR 
    const { areas_list }:any  = useSelector( (state:any) => state.areas );


    // FORM FIELDS 
    const { formField: {
        name,
        description,
        area,
        visita_domiciliaria,
        prueba_psicotecnica,
        examen_alimentos,
        examen_alturas,
        certificado_laboral,
        certificado_estudios,
        adres,
        antecedentes_judicial,
        entrevista,
        sociodemografica,
        dme,
        sst,
      }
    } = props;


            


    // USE EFFECT 
    useEffect(() => {

       const areas:any = [];

       for (let index = 0; index < areas_list.length; index++) {
           
           const data = {
              label: areas_list[index].name,
              value: areas_list[index].id
           }
           areas.push(data);
        
       }
       setAreasSelect(areas);

    }, [areas_list]);

   
    
    // CONST STYLE 
    const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button,
        backgroundColor: 'wheat',
        padding: theme.spacing(8),
        textAlign: 'center'
    }));
    
    
  return (
    <div>
        
        <Grid>
            <Grid size={12} sx={{ padding: 2 }}>
                <InputField 
                name={name.name}
                label={name.label}
                variant="outlined"
                autoComplete="off" 
                fullWidth
                />
            </Grid>
        </Grid>
        <Grid>
            <Grid size={12} sx={{ padding: 2 }}>
                <TextAreaField 
                name={description.name}
                label={description.label}
                variant="outlined"
                autoComplete="off" 
                fullWidth
                />
            </Grid>
        </Grid>
        {
            areas_select.length > 0

               ?
                    <Grid size={12} sx={{ padding: 2 }}>
                            <AutocompleteField  
                                options={areas_select}
                                name={area.name}
                                label={area.label}
                                element={area.name}
                            />
                            
                    </Grid>
               :

               <Div>{"No hay areas disponibles..."}</Div>
        }

        <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={visita_domiciliaria.name} label={visita_domiciliaria.label}/>
                 </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={prueba_psicotecnica.name} label={prueba_psicotecnica.label}/>
                </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={examen_alimentos.name} label={examen_alimentos.label}/>
                </div>
            </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={examen_alturas.name} label={examen_alturas.label}/>
                 </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={certificado_laboral.name} label={certificado_laboral.label}/>
                </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={certificado_estudios.name} label={certificado_estudios.label}/>
                </div>
            </Grid>
        </Grid>


        <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={adres.name} label={adres.label}/>
                 </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={antecedentes_judicial.name} label={antecedentes_judicial.label}/>
                </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={entrevista.name} label={entrevista.label}/>
                </div>
            </Grid>
        </Grid>


        <Grid container spacing={2} sx={{ padding: 2 }}>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={sociodemografica.name} label={sociodemografica.label}/>
                 </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={dme.name} label={dme.label}/>
                </div>
            </Grid>
            <Grid size={4} sx={{ padding: 2 }}>
                <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                    <CheckboxField  name={sst.name} label={sst.label}/>
                </div>
            </Grid>
        </Grid>
        
    </div>
  )
}

